import React, { ReactElement } from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";

type ActionableAlertProps = {
  icon: ReactElement;
  title: string;
  message: string;
  confirmText: string;
  onConfirm: () => void;
};

const ActionableAlert: React.FC<ActionableAlertProps> = ({
  icon,
  title,
  message,
  confirmText,
  onConfirm,
}) => {
  const { palette } = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      color={palette.warning.contrastText}
      borderRadius={2}
      sx={{
        backgroundColor: palette.warning.main,
      }}
    >
      <Box
        display="flex"
        flexDirection="row"
        gap={2}
        padding={2}
        borderBottom="1px solid"
        borderColor={palette.warning.dark}
      >
        <Box width={24}>{icon}</Box>
        <Box display="flex" flexDirection="column" gap={1}>
          <Typography variant="prose-base-medium">{title}</Typography>
          <Typography variant="prose-sm">{message}</Typography>
        </Box>
      </Box>
      <Button onClick={onConfirm} size="large" variant="text" fullWidth sx={{ borderRadius: 0 }}>
        <Typography color={palette.warning.contrastText} variant="prose-base-medium">
          {confirmText}
        </Typography>
      </Button>
    </Box>
  );
};

export { ActionableAlert };
